<template>
	<header class="header">
		<button type="button" class="btn-close" @click="closeModal" />
		<div class="title">
			{{ title }}
		</div>
		<span
			@click="callAction"
			class="action-button"
			:class="{ disabled: actionDisabled }"
		>
			{{ actionText }}
		</span>
	</header>
</template>

<script>
export default {
	name: 'FullScreenModalHeader',

	props: {
		title: {
			type: String,
			default: ''
		},
		actionText: {
			type: String,
			default: ''
		},
		actionDisabled: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		closeModal() {
			this.$emit('close')
		},

		callAction() {
			this.$emit('action')
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px;
	color: #fff;
	background-color: $background-dark;

	.title {
		font-size: 20px;
		color: rgb(255, 255, 255);
	}

	.action-button {
		cursor: pointer;
	}
}
</style>
